import React from 'react';
import { Row, Col, Divider } from 'antd';
import { Button, Text, Title } from 'components';
import styled from 'styled-components';
import { RightOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectNoticias, selectNoticiasHome } from 'store/app';
import { Link } from 'react-router-dom';

const NewsItem = ({ item, width }) => (
  <NewsCard style={{ width }}>
    <Img src={item.imagen} />
    <NewsCardContentContainer>
      <Link to={`/noticias/noticia/${item.key}`}>
        <Title style={{ margin: 0 }} level={4} $accent className="ellipsis2">{item.titulo}</Title>
      </Link>
      <Text className="ellipsis4">{item.resumen}</Text>
      <Button type="link" style={{ padding: '10px 0 10px 0' }} $accent>
        <Link to={`/noticias/noticia/${item.key}`}>
          <Text $accent $sm strong>
            <Text style={{ color: 'inherit' }}>CONSULTAR</Text>
            <RightOutlined style={{ color: 'inherit' }} />
          </Text>
        </Link>
      </Button>
      <Divider style={{ margin: '5px 0 5px 0' }} />
      <Text $xs strong $accent>{item.fecha_publicacion}</Text>
    </NewsCardContentContainer>
  </NewsCard>
);

NewsItem.propTypes = {
  item: PropTypes.shape({
    fecha_publicacion: PropTypes.string,
    imagen: PropTypes.string,
    titulo: PropTypes.string,
    resumen: PropTypes.string,
    enlace: PropTypes.string,
    key: PropTypes.string,
  }).isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

const NewsGallery = ({ noticias, home }) => (
  <Row gutter={[15, 15]} style={{ padding: '10px 0 10px 10px', width: '100%' }}>
    {noticias.map((item) => (
      <Col xs={24} sm={24} md={home ? 8 : 12} xl={8} key={item.id}>
        <NewsItem width="100%" item={item} />
      </Col>
    ))}
  </Row>
);

NewsGallery.propTypes = {
  noticias: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  home: PropTypes.bool,
};

NewsGallery.defaultProps = {
  home: false,
};

// const NewsCarrousel = ({ noticias }) => (
//   <NewsCarrouselContainer justifyContent style={{ paddingInline: 10 }}>
//     {noticias.filter((e) => e.publicar_en_portada).map((item) => (
//       <NewsItemWrapper key={item.id}>
//         <NewsItem item={item} width={300} />
//       </NewsItemWrapper>
//     ))}
//   </NewsCarrouselContainer>
// );

// NewsCarrousel.propTypes = { noticias: PropTypes.arrayOf(PropTypes.shape()).isRequired };

const NewsList = ({ home }) => {
  if (home) {
    const noticiasHome = useSelector(selectNoticiasHome);
    if (!noticiasHome.length) return null;

    return (
      <>
        <Col span={24} style={{ marginTop: 20, paddingLeft: 10 }}>
          <Title level={2} $accent>Noticias Recientes</Title>
        </Col>
        <NewsGallery home noticias={noticiasHome} />
        <Row justify="end" style={{ paddingTop: 10, paddingRight: 10 }}>
          <Link to="/noticias">
            <Text $accent>
              <Text style={{ color: 'inherit' }}>
                Ver todas las noticias
              </Text>
              <RightOutlined />
            </Text>
          </Link>
        </Row>
        <Col span={24} style={{ marginBottom: 20 }} />
      </>
    );
  }

  const noticias = useSelector(selectNoticias);
  if (!noticias.results.length) return null;

  return (
    <NewsGallery noticias={noticias.results} />
  );
};

NewsList.propTypes = { home: PropTypes.bool };

NewsList.defaultProps = { home: false };

// const NewsCarrouselContainer = styled.div`
//   display: flex;
//   flex-direction: row;
//   justify-content: ${(props) => (props.justifyContent ? 'center' : '')};
//   overflow: scroll hidden;
//   scroll-snap-type: x mandatory;
//   width: 100%;
// `;

// const NewsItemWrapper = styled.div`
//   scroll-snap-align: start;
//   padding: 10px;
// `;

const NewsCard = styled.div`
  border-radius: 12px;
  box-shadow: 1px 0px 2px 2px #cacaca;
  background-color: #FFFFFF;
  height: 480px;
  img {
    border-radius: 12px 12px 0 0;
    height: 200px;
  }
  .ellipsis2 {
    -webkit-line-clamp: 2;
    height: 60;
    -webkit-line-clamp: 2;
    overflow: hidden;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }
  .ellipsis4 {
    -webkit-line-clamp: 4;
    height: 115px;
    -webkit-line-clamp: 4;
    overflow: hidden;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }
`;

const NewsCardContentContainer = styled.div`
  padding: 15px;
`;

const Img = styled.img.attrs({ draggable: false })`
  width: 100%;
  object-fit: cover;
  user-select: none;
`;

export default NewsList;
